import React from "react";
import Dcards from "./Dcards";
import "./Destinations.css";
import Sdata from "./Sdata";
const AllItem = () => {
  const items = Sdata;
  return (
    <>
      <section className="gallery desi mtop">
        <div className="container">
          <div
            className=""
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              margin: "0 auto",
            }}
          >
            {items.map((item) => {
              return <Dcards key={item.id} item={item} />;
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default AllItem;
